/* import ordersApi from "../../api/orders" */
import Vue from "vue"

import utilsApi, { schedulePickUp } from "../../api/utils"
import utils from "@/utils/utils"

const optimizeCartLineItems = (lineItems) => {
  return lineItems.reduce((accumulator, current) => {
    let result = { ...current }
    if (typeof current.productId == "object") {
      result = {
        ...result,
        productId: current.productId?._id
      }
    }
    if (typeof current.variationId == "object") {
      result = {
        ...result,
        variationId: current.variationId?._id
      }
    }
    accumulator.push(result)
    return accumulator
  }, [])
}

const initialObject = {
  _id: undefined,
  order_number: undefined,
  customer: undefined,
  line_items: [],
  sale_price: undefined,
  price: undefined,
  discount: undefined,
  coupon_applied: undefined,
  currency: undefined,
  order_notes: undefined,
  shipping_rate: undefined,
  shipping_method: undefined,
  different_address: undefined,
  packaging: undefined,
  shipping_metadata: [],
  return_metadata: [],
  billing_address: {
    first_name: undefined,
    last_name: undefined,
    phone: undefined,
    address: undefined,
    address_extra: undefined,
    post_code: undefined,
    city: undefined,
    country: undefined,
    province: undefined
  },
  shipping_address: {
    first_name: undefined,
    last_name: undefined,
    phone: undefined,
    address: undefined,
    address_extra: undefined,
    post_code: undefined,
    city: undefined,
    country: undefined,
    province: undefined
  },
  //no se debe mandar cosas que no se editan desde aca, esto reinicia el objeto siempre
  //coupon_applied: undefined,
  pick_up: null,
  status: undefined,
  createdAt: undefined,
  updatedAt: undefined
}
const ignoreObjectsFields = ["createdAt", "updatedAt", "label_data"]
// general state for the site

const initialState = {
  orders: [],
  count: 0,
  page: 1,
  sortBy: "order_number",
  sortDirection: "desc",
  statusFilter: [],
  fetched: false,
  error: false,
  object: initialObject,
  isNew: false,
  selected: [],
  shippingMethods: [],
  shippingMethodsObjs: [],
  shippingRates: [],
  uploadDryRun: false
}

const state = Object.assign({}, initialState)

const getters = {
  orders: (state) => state.orders,
  ordersIndex: (state) => (payload) => {
    const { param, parent, key } = payload || {}
    return payload
      ? param
        ? key
          ? parent
            ? state[param] && state[param][parent] && state[param][parent][key]
              ? state[param][parent][key]
              : undefined
            : state[param] && state[param][key]
            ? state[param][key]
            : undefined
          : state[param]
          ? state[param]
          : undefined
        : state
      : state
  },
  ordersError: (state) => state.error,
  orders_Object: (state) => state.object,
  orders_isNew: (state) => state.isNew,
  orders_selected: (state) => state.selected,

  orders_shippingMethods: (state) => state.shippingMethods,
  orders_shippingMethodsObjs: (state) => state.shippingMethodsObjs,
  orders_shippingRates: (state) => state.shippingRates
}
const actions = {
  async GET_GUIDE_orders(
    { state, rootGetters, commit, dispatch },
    { packageIndex, isReturn }
  ) {
    const { shipping_method } = state.object

    if (shipping_method != "shippo") {
      let apiResponse = await utilsApi.getGuide(state.object)
      if (apiResponse != null) {
        //console.log("HOLA get guide", apiResponse)
        const { rta, order } = apiResponse
        const { rotulos, error } = rta
        if (error) {
          commit("ORDERS_ERROR")
          return false
        } else {
          dispatch("FETCH_orders")
          commit("SET_OBJECT_ORDER", order)
          if (rotulos) {
            const linkSource = `data:application/pdf;base64,${rotulos}`
            const downloadLink = document.createElement("a")
            const fileName =
              "GUIA-COORDINADORA-" + state.object.order_number + ".pdf"

            downloadLink.href = linkSource
            downloadLink.download = fileName
            downloadLink.click()
            return true
          }
          commit("ORDERS_ERROR")
          return false
        }
      } else {
        commit("ORDERS_ERROR")
        return false
      }
    } else {
      const order = state.object
      const site = rootGetters.site

      const labelUrl = utils.labelUrlMaker({
        site,
        order,
        index: packageIndex,
        isReturn
      })

      if (labelUrl) {
        window.open(labelUrl, "_blank", "noopener,noreferrer")
        return true
      } else {
        commit("ORDERS_ERROR")
        return false
      }
    }
  },

  async CANCEL_SHIPMENT_orders({ state, dispatch }) {
    let apiResponse = await utilsApi.cancelShipment(state.object)

    if (apiResponse != null) {
      const { shipping_metadata } = state.object

      const updatedObject = shipping_metadata.map((metadata) => {
        if (metadata.label_status === "active") {
          return {
            ...metadata,
            label_status: "cancelled"
          }
        }
        return metadata
      })

      dispatch("UPDATE_orders", {
        ...state.object,
        status: "cancelled",
        shipping_metadata: updatedObject
      })

      return true
    } else {
      return false
    }
  },

  async CREATE_LABEL_orders(
    { state, commit, dispatch },
    { packageIndex, isReturn, forceRateFetch = false }
  ) {
    const { shipping_method, _id } = state.object
    let apiResponse = await utilsApi.createLabel(
      shipping_method,
      _id,
      packageIndex,
      isReturn,
      forceRateFetch
    )
    if (apiResponse != null) {
      const { order, error } = apiResponse
      if (error) {
        commit("ORDERS_ERROR")
        return false
      } else {
        dispatch("FETCH_PAGE_orders", state.page)
        commit("SET_OBJECT_ORDER", order)
        return true
      }
    } else {
      commit("ORDERS_ERROR")
      return false
    }
  },

  async SCHEDULE_PICKUP_orders({ state, commit, dispatch }) {
    let apiResponse = await schedulePickUp(state.object)
    if (apiResponse != null) {
      //console.log("HOLA get guide", apiResponse)
      const { rta, order, error } = apiResponse
      if (error) {
        commit("ORDERS_ERROR")
        return false
      } else {
        dispatch("FETCH_PAGE_orders", state.page)
        commit("SET_OBJECT_ORDER", order)
        return rta
      }
    } else {
      commit("ORDERS_ERROR")
      return false
    }
  },

  UPDATE_SHIPPING_RATES_orders({ commit, state }, code) {
    let service = state.shippingMethods.find((option) => {
      return option.code == code
    })
    const { packaging, rates } = service
    commit("SHIPPING_RATES_SETTING", rates)
    commit("SET_ORDER_FIELD", { value: packaging, field: "packaging" })
    return true
  },

  async DELETE_orders({ commit, dispatch, state }, object) {
    const filtered = Object.keys(object)
      .filter((key) => !ignoreObjectsFields.includes(key))
      .reduce((obj, key) => {
        obj[key] = object[key]
        return obj
      }, {})
    const optimizedLineItems = optimizeCartLineItems(filtered.line_items)

    //console.log("OPTIMIZED PRODUCTTS", filtered, optimizedLineitems)

    const filteredAndOptimize = {
      ...filtered,
      products: optimizedLineItems
    }

    let apiResponse = await utilsApi.deleteObject("orders", filteredAndOptimize)
    if (apiResponse != null) {
      //commit("ORDERS_SETTING", apiResponse)
      dispatch("FETCH_PAGE_orders", state.page)
      return true
    } else {
      commit("ORDERS_ERROR")
      return false
    }
  },

  async DELETE_SELECTED_orders({ state, dispatch, commit }) {
    let deletions = await Promise.all(
      state.selected.map(async (current) => {
        return await dispatch("DELETE_orders", current)
      })
    )
    if (deletions.includes(false)) {
      return false
    } else {
      //dispatch("FETCH_PAGE_orders")
      commit("SET_orders", {
        param: "selected",
        value: []
      })
      return true
    }
  },

  UPDATE_FIELD_orders({ commit }, payload) {
    commit("SET_orders", payload)
    return true
  },

  UPDATE_ordersState({ commit }, payload) {
    commit("SET_orders", payload)
    return true
  },
  async UPDATE_orders({ commit, dispatch, state }, object) {
    let apiResponse
    if (object == null) {
      const filtered = Object.keys(state.object)
        .filter((key) => !ignoreObjectsFields.includes(key))
        .reduce((obj, key) => {
          obj[key] = state.object[key]
          return obj
        }, {})
      const optimizedLineItems = optimizeCartLineItems(filtered.line_items)

      //console.log("OPTIMIZED PRODUCTTS", filtered, optimizedLineItems)

      const filteredAndOptimize = {
        ...filtered,
        products: optimizedLineItems
      }

      apiResponse = await utilsApi.updateObject("orders", filteredAndOptimize)
    } else {
      const filtered = Object.keys(object)
        .filter((key) => !ignoreObjectsFields.includes(key))
        .reduce((obj, key) => {
          obj[key] = object[key]
          return obj
        }, {})

      const optimizedLineItems = optimizeCartLineItems(filtered.line_items)

      //console.log("OPTIMIZED PRODUCTTS", filtered, optimizedLineItems)

      const filteredAndOptimize = {
        ...filtered,
        products: optimizedLineItems
      }
      apiResponse = await utilsApi.updateObject("orders", filteredAndOptimize)
    }

    if (apiResponse != null) {
      commit("SET_OBJECT_ORDER", apiResponse?.order)
      dispatch("FETCH_PAGE_orders", state.page)
      return true
    } else {
      commit("ORDERS_ERROR")
      return false
    }
  },
  async CREATE_orders({ commit, dispatch, state }, object) {
    let apiResponse
    if (object == null) {
      apiResponse = await utilsApi.createObject("orders", state.object)
    } else {
      apiResponse = await utilsApi.createObject("orders", object)
    }
    if (apiResponse != null) {
      commit("ORDERS_SETTING", apiResponse)
      commit("SET_OBJECT_ORDER", apiResponse.result)
      dispatch("FETCH_PAGE_orders", state.page)
      return true
    } else {
      commit("ORDERS_ERROR")
      return false
    }
  },
  async FETCH_orders({ commit }) {
    let apiResponse = await utilsApi.getObjects("orders")
    //console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("ORDERS_SETTING", apiResponse)
      return true
    } else {
      commit("ORDERS_ERROR")
      return false
    }
  },
  async FETCH_PAGE_orders({ commit, state }, page) {
    const sortParams = {
      sortBy: state.sortBy,
      sortDirection: state.sortDirection
    }
    if (state.statusFilter && state.statusFilter.length > 0) {
      sortParams.statusIn = state.statusFilter.join(",")
    }
    let apiResponse = await utilsApi.getObjectsPage("orders", page, sortParams)
    //console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("ORDERS_SETTING", { ...apiResponse, page })
      return true
    } else {
      commit("ORDERS_ERROR")
      return false
    }
  },
  async APPLY_FILTERS_orders({ commit, dispatch }, { sortDirection, statusFilter }) {
    commit("SET_orders", { param: "sortBy", value: "order_number" })
    commit("SET_orders", { param: "sortDirection", value: sortDirection })
    commit("SET_orders", { param: "statusFilter", value: statusFilter })
    return dispatch("FETCH_PAGE_orders", 1)
  },
  UPDATE_OBJECT_orders({ commit }, payload) {
    commit("SET_OBJECT_ORDER", payload)
    return true
  },
  CLEAN_OBJECT_orders({ commit }) {
    commit("SET_OBJECT_ORDER_INITIAL")
    commit("SHIPPING_METHODS_SETTING", [])
    commit("SHIPPING_METHODS_OBJS_SETTING", [])
    commit("SHIPPING_RATES_SETTING", [])
    return true
  },
  async CLEAN_STORE_orders({ commit }) {
    const initialStateKeys = Object.keys(initialState)
    await Promise.all(
      initialStateKeys.map(async (current) => {
        await commit("SET_orders", {
          param: current,
          value: initialState[current]
        })
        return true
      })
    )
    return true
  },
  UPDATE_SELECTED_orders({ commit }, payload) {
    commit("SET_SELECTED_ORDERS", payload)
    return true
  },
  UPDATE_STATE_ORDERS({ commit }, payload) {
    commit("SET_orders", payload)
    return true
  }
}
const mutations = {
  ORDERS_SETTING: (state, { orders, count = false, page }) => {
    //console.log(state)
    state.page = page || state.page
    state.count = count || state.orders.length
    state.orders = orders
    state.fetched = true
    state.error = false
  },
  ORDERS_ERROR: (state) => {
    state.orders = null
    state.fetched = true
    state.error = true
  },
  SET_OBJECT_ORDER: (state, payload) => {
    Object.keys(initialObject).map((key) => {
      state.object[key] = payload[key]
    })
  },

  SET_OBJECT_ORDER_INITIAL: (state) => {
    state.object = { ...state.object, ...initialObject }
  },
  SET_SELECTED_ORDERS: (state, selectedOrders) => {
    state.selected = selectedOrders
  },

  SHIPPING_METHODS_SETTING: (state, payload) => {
    state.shippingMethods = payload
  },
  SHIPPING_METHODS_OBJS_SETTING: (state, payload) => {
    state.shippingMethodsObjs = payload
  },
  SHIPPING_RATES_SETTING: (state, payload) => {
    state.shippingRates = payload
  },
  SET_orders: (state, payload) => {
    const { param, parent, key, value } = payload
    //console.log("SETTING FORMS STATE IN", param, value, key, parent)
    key
      ? parent
        ? state[param]
          ? state[param][parent]
            ? Vue.set(state[param][parent], key, value)
            : Vue.set(state[param], parent, {}) &&
              Vue.set(state[param][parent], key, value)
          : Vue.set(state, param, {}) &&
            Vue.set(state[param], parent, {}) &&
            Vue.set(state[param][parent], key, value)
        : state[param]
        ? Vue.set(state[param], key, value)
        : Vue.set(state, param, {}) && Vue.set(state[param], key, value)
      : Vue.set(state, param, value)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
